export const getQueryParams = (params) => {
    return Object.entries(params)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
};

export const handleResponse = (resp) => {
    const { success, data } = resp.data;
    const message = resp.data.message;
    return { success, message, data };
};

export const handleError = (error) => {
    if (error.response && error.response.data) {
        return {
            success: false,
            message: error.response.data.message
        };
    }
    return {
        success: false,
        message: 'Oops something went wrong.',
        exception: {
            code: error.code,
            message: error.message
        }
    };
};
